import { DialogFooter } from "../../dialog-footer";
import styles from "./confirm-footer.module.scss";
import type { ConfirmFooterViewProps } from "./types-confirm-footer";

export function ConfirmFooterView({
  error,
  errorTestId,
  testIdPrefix,
  destructive,
  pending,
  acceptLabel,
  rejectLabel,
  acceptIcon,
  rejectIcon,
  acceptClassName,
  rejectClassName,
  acceptAutoFocus,
  rejectAutoFocus,
  reject,
  accept,
}: ConfirmFooterViewProps) {
  return (
    <>
      {error ? (
        <p role="alert" className={styles.error} data-testid={errorTestId}>
          {error}
        </p>
      ) : null}
      <DialogFooter
        testId={testIdPrefix}
        cancelLabel={rejectLabel}
        confirmLabel={acceptLabel}
        cancelVariant="outlined"
        severity={destructive ? "danger" : "primary"}
        locked={pending}
        loading={pending}
        onCancel={reject}
        onConfirm={accept}
        cancelClassName={rejectClassName}
        confirmClassName={acceptClassName}
        cancelButtonProps={{ icon: rejectIcon, autoFocus: rejectAutoFocus }}
        confirmButtonProps={{ icon: acceptIcon, autoFocus: acceptAutoFocus }}
      />
    </>
  );
}
